import React, {useState, useContext} from 'react';
import UpdateNoteView from './UpdateNoteView';
import api from '../../../../axios.config';
import Spinner from '../../../Spinner/Spinner';
import swal from 'sweetalert';
import {deleteNote} from '../../../../services/MadricService';
import {useLocation} from 'react-router-dom';
import {useNavigate} from 'react-router';
import {MadricContext} from '../../../../Context/MadricContext';

/**
 * Permet l'ajout des médias
 * @return {JSX}
 */
function UpdateNote() {
  const [isLoading, setIsLoading] = useState(false);
  const {projectInfo, setProjectInfo, setWhatToShow} = useContext(MadricContext);

  const navigate = useNavigate();
  const location = useLocation();

  const [form, setForm] = useState({
    id: location.state.note.id,
    note: location.state.note.note,
    selectedDate: location.state.note.date,
    extra1: location.state.note.extra1,
    extra2: location.state.note.extra2,
    extra3: location.state.note.extra3,
  });


  const openModal = () => {
    swal('Votre note a été enregistré');
  };

  const handleChangeValue = (event) => {
    setForm({
      ...form,
      [event.target.name]: event.target.value,
    });
  };

  const handleChangeCheckbox = (event) => {
    setForm({
      ...form,
      [event.target.name]: event.target.checked,
    });
  };

  /**
   * Ferme le modal
   */
  function closeModal() {
    if(location.state.returnTo === 'global')
    {
      navigate('/InfoGlobal');
    }
    else if(location.state.returnTo === 'historique')
    {
      setWhatToShow('7');
      navigate('/chantier/' + location.state.id);
    }
    else
    {
      setWhatToShow('6');
      navigate('/chantier/' + location.state.id);
    }
  }

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);

    await api.put('/notes/' + location.state.note.id, {
      note: form.note,
      date: form.selectedDate,
      extra1: form.extra1,
      extra2: form.extra2,
      extra3: form.extra3,
    }).then(() =>{ 
      openModal();
    }).finally(() => {
      setIsLoading(false);

      const updatedNote = projectInfo.map((p) => {
        if (p.id === form.id && p.type === 'note') {
          return {
            ...p,
            note: form.note,
            date: form.selectedDate,
            extra1: form.extra1,
            extra2: form.extra2,
            extra3: form.extra3,
          };
        }
        return p;
      });
      updatedNote.filter((r) => r.type === 'note').sort((a, b) => {
        const dateCompare = b.date.localeCompare(a.date);
        if (dateCompare !== 0) {
          return dateCompare;
        }

        return b.user_id - a.user_id;
      });
      setProjectInfo(updatedNote);

      if(location.state.returnTo === 'global')
      {
        navigate('/InfoGlobal');
      }
      else if(location.state.returnTo === 'historique')
      {
        setWhatToShow('7');
        navigate('/chantier/' + location.state.id);
      }
      else
      {
        setWhatToShow('6');
        navigate('/chantier/' + location.state.id);
      }
    });
  };

  /**
   * Supprime la note
   */
  function handleDelete() {
    swal({
      title: 'Êtes-vous sûre de vouloir supprimer cette note',
      text: 'Une fois supprimer vous n\'y aurai plus accès',
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    })
        .then(async (willDelete) => {
          if (willDelete) {
            setIsLoading(true);
            const filtered = projectInfo.map((obj) => {
              return obj.id === form.id && obj.type === 'note' ? null : obj;
            }).filter((item) => item !== null);

            setProjectInfo(filtered);

            await deleteNote(location.state.note.id, location.state.id);
            setIsLoading(false);

            swal('Supprimé!', {
              icon: 'success',
            });

            if(location.state.returnTo === 'global')
            {
              navigate('/InfoGlobal');
            }
            else if(location.state.returnTo === 'historique')
            {
              setWhatToShow('7');
              navigate('/chantier/' + location.state.id);
            }
            else
            {
              setWhatToShow('6');
              navigate('/chantier/' + location.state.id);
            }
            
          } else {
            swal('Annulé!');
          }
        });
  }

  return (
    <React.Fragment>
      {isLoading && <Spinner />}
      <UpdateNoteView
        handleSubmit={handleSubmit}
        handleChangeValue={handleChangeValue}
        handleChangeCheckbox={handleChangeCheckbox}
        closeModal={closeModal}
        handleDelete={handleDelete}
        form={form}
        setForm={setForm}
      />
    </React.Fragment>
  );
}

export default UpdateNote;
